<template>
  <dx-modal title="Nova conta interna"
            :value="show"
            :closable="!saving"
            @input="close()"
            size="sm"
            id="modal-cash-register-bank-account">
    <div class="stenci-group stenci-alert bank-account-help">
      <p>
        Conta interna guarda o dinheiro em espécie (caixa, cofre, tesouraria).
        Contas bancárias são cadastradas em Financeiro › Contas financeiras.
      </p>
    </div>
    <div class="form-group" :class="{'has-error': $v.form.name.$error}">
      <label class="form-label">Nome</label>
      <input type="text" class="form-input" v-model="form.name"
             placeholder="Caixa da recepção" v-focus
             @blur="$v.form.name.$touch()" @keypress.enter="save">
      <div class="form-input-hint" v-if="$v.form.name.$error">Campo obrigatório</div>
    </div>
    <template slot="footer">
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              :class="{loading: saving}" :disabled="saving" @click="save">
        <fa-icon :icon="['fal', 'check']"/>Salvar
      </button>
      <button class="btn" :disabled="saving" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      form: {
        name: '',
      },
    };
  },
  validations() {
    return {
      form: {
        name: { required },
      },
    };
  },
  methods: {
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error || this.saving) return;

      this.saving = true;
      const name = this.form.name.trim();

      try {
        const { data: found } = await this.$http.get('/bank-accounts', { params: { name } });
        if (found.items.length > 0) {
          this.$toast.error('Já existe uma conta com este nome.');
          return;
        }

        const { data } = await this.$http.post('/bank-accounts', {
          name,
          cashier: true,
          active: true,
        });
        this.$toast.success('Conta interna criada.');
        this.$emit('saved', data);
        this.close();
      } catch (e) {
        this.$toast.error(e);
      } finally {
        this.saving = false;
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
#modal-cash-register-bank-account {
  .bank-account-help {
    font-size: $font-size-sm;
    margin-top: 0;
    p { margin: 0; }
  }
}
</style>
